import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnID: CultureInfo = {
  name: 'en-ID',
  displayName: 'English (Indonesia)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-ID',
  parent: CultureInfoEn
};
